import PropTypes from "prop-types";
import React, { Component } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import MCard from "components/Shared/MCard.tsx";

class SketchImageWrapper extends Component {
    constructor(){
        super();
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);

        this.state = {
            visible: false
        };
    }

    show(){
        this.setState({visible: true});
    }

    hide(){
        this.setState({visible: false});    
    }

    render(){
        return (
            <div className="PhotoWrapper">
                <MCard 
                    title={`Sketch ${this.props.number}`}
                    style="cursor: zoom-in; margin-right: 2px;"
                    disableHoverStyles
                >
                    <div className="PhotoContainer" onClick={this.show} style={{ height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <img src={this.props.src + "&" + new Date().getTime()} /> 
                    </div>
                </MCard>
                <Dialog
                    id="sketch-photo-dialog"
                    open={this.state.visible}
                    onClose={this.hide}
                    sx={{ '& .MuiDialog-paper': { width: 'fit-content' } }}>
                    <DialogTitle>{`Sketch ${this.props.number}`}</DialogTitle>
                    <DialogContent>
                        <img width="100%" src={this.props.src + "&" + new Date().getTime()} />
                    </DialogContent>
                </Dialog>
            </div>
        );
    }
}

SketchImageWrapper.propTypes = {
    src: PropTypes.string.isRequired,
    number: PropTypes.number.isRequired,
};

export default SketchImageWrapper;
